import { type JSX, Show, onCleanup, onMount } from 'solid-js'

export const ACTION_BAR_HEIGHT_VAR = '--ds-action-bar-height'

const mountedBars = new Set<HTMLElement>()

const publishHeight = () => {
  let tallest = 0
  for (const bar of mountedBars) {
    tallest = Math.max(tallest, bar.offsetHeight)
  }
  if (tallest === 0) {
    document.documentElement.style.removeProperty(ACTION_BAR_HEIGHT_VAR)
    return
  }
  document.documentElement.style.setProperty(ACTION_BAR_HEIGHT_VAR, `${tallest}px`)
}

export interface WizardActionBarProps {
  left?: JSX.Element
  right?: JSX.Element
  note?: JSX.Element
  contentClass?: string
  class?: string
}

export function WizardActionBar(props: WizardActionBarProps) {
  let barRef: HTMLDivElement | undefined

  onMount(() => {
    const bar = barRef
    if (!bar) {
      return
    }
    mountedBars.add(bar)
    publishHeight()
    onCleanup(() => {
      mountedBars.delete(bar)
      publishHeight()
    })

    if (typeof ResizeObserver === 'undefined') {
      return
    }
    const observer = new ResizeObserver(publishHeight)
    observer.observe(bar)
    onCleanup(() => observer.disconnect())
  })

  return (
    <div
      ref={barRef}
      class={`sticky bottom-0 z-10 border-t border-[var(--color-border)] bg-[var(--color-surface)] px-4 sm:px-6 lg:px-8 py-4 shadow-[var(--shadow-bar-top)] ${props.class ?? ''}`}
    >
      <div
        class={`flex items-center justify-between gap-4 ${props.note ? 'flex-wrap' : ''} ${props.contentClass ?? ''}`}
      >
        <Show when={props.note}>
          <div data-action-bar-note class="w-full basis-full">
            {props.note}
          </div>
        </Show>
        <div class="flex items-center gap-3">{props.left}</div>
        <div class="flex items-center gap-3">{props.right}</div>
      </div>
    </div>
  )
}
